import { render, staticRenderFns } from "./MenuFooter.vue?vue&type=template&id=6135b64a&scoped=true&"
import script from "./MenuFooter.vue?vue&type=script&lang=js&"
export * from "./MenuFooter.vue?vue&type=script&lang=js&"
import style0 from "./MenuFooter.vue?vue&type=style&index=0&id=6135b64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6135b64a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6135b64a')) {
      api.createRecord('6135b64a', component.options)
    } else {
      api.reload('6135b64a', component.options)
    }
    module.hot.accept("./MenuFooter.vue?vue&type=template&id=6135b64a&scoped=true&", function () {
      api.rerender('6135b64a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/leftNavBar/MenuFooter.vue"
export default component.exports